/** Rubia Gallega experience goes live on 26 June 2026 at 21:00 (Europe/Rome). */
export const RUBIA_GALLEGA_LAUNCH_AT = new Date('2026-06-26T21:00:00+02:00');

/** End of Wagyu Experience event day (Europe/Rome). */
export const WAGYU_EXPERIENCE_END_AT = new Date('2026-06-26T23:59:59+02:00');

/** End of Rubia Gallega event day (Europe/Rome). */
export const RUBIA_GALLEGA_EVENT_END_AT = new Date('2026-07-23T23:59:59+02:00');

/** Home holiday notice: 17 September 2026 00:00 until midnight at the end of 11 October (Europe/Rome). */
export const HOLIDAY_NOTICE_START_AT = new Date('2026-09-17T00:00:00+02:00');
export const HOLIDAY_NOTICE_END_AT = new Date('2026-10-12T00:00:00+02:00');

/** New menu (PDFs + home slide) goes live when the holiday notice ends. */
export const NEW_MENU_LAUNCH_AT = HOLIDAY_NOTICE_END_AT;

/** Holiday menus (home slide) stay up until the end of 6 January 2027 (Europe/Rome). */
export const HOLIDAY_MENUS_END_AT = new Date('2027-01-07T00:00:00+01:00');

export type ExperienceVariant = 'legacy' | 'rubia';

export function isRubiaGallegaExperienceLive(now = new Date()): boolean {
  return now >= RUBIA_GALLEGA_LAUNCH_AT;
}

export function isHolidayNoticeVisible(now = new Date()): boolean {
  return now >= HOLIDAY_NOTICE_START_AT && now < HOLIDAY_NOTICE_END_AT;
}

export function isNewMenuLive(now = new Date()): boolean {
  return now >= NEW_MENU_LAUNCH_AT;
}

export function isHolidayMenusLive(now = new Date()): boolean {
  return now < HOLIDAY_MENUS_END_AT;
}

/** Returns the active timed experience variant, or null if the event is over or not yet started. */
export function getActiveExperienceVariant(now = new Date()): ExperienceVariant | null {
  if (isHolidayNoticeVisible(now)) {
    return null;
  }
  if (now >= RUBIA_GALLEGA_LAUNCH_AT && now <= RUBIA_GALLEGA_EVENT_END_AT) {
    return 'rubia';
  }
  if (now < RUBIA_GALLEGA_LAUNCH_AT && now <= WAGYU_EXPERIENCE_END_AT) {
    return 'legacy';
  }
  return null;
}

export function isTimedExperienceVisible(now = new Date()): boolean {
  return getActiveExperienceVariant(now) !== null;
}
